import { Route, Routes } from 'react-router-dom';

import ProtectedRoute from './ProtectedRoute';
import Category from '../pages/Category';
import DatasetDetails from '../pages/DatasetDetails';
import Home from '../pages/Home';
import Profile from '../pages/Profile';
import PurchasedDataset from '../pages/PurchasedDataset';
import Orders from '../pages/Orders';
import WishList from '../pages/WishList';
import Search from '../pages/Search';
import TempSearch from '../pages/TempSearch';
import Cart from '../pages/Cart';
import Tickets from '../pages/Tickets';
import TicketDetails from '../pages/TicketDetails';

const CommonRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/category/:name' element={<Category />} />
      <Route path='/dataset-detail/:name' element={<DatasetDetails />} />
      <Route path='/search' element={<TempSearch />} />
      <Route path='/search/:text' element={<Search />} />
      <Route
        path='/cart'
        element={
          <ProtectedRoute>
            <Cart />
          </ProtectedRoute>
        }
      />
      <Route
        path='/profile'
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path='/purchased-dataset'
        element={
          <ProtectedRoute>
            <PurchasedDataset />
          </ProtectedRoute>
        }
      />
      <Route
        path='/order-history'
        element={
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        }
      />
      <Route
        path='/my-wishlist'
        element={
          <ProtectedRoute>
            <WishList />
          </ProtectedRoute>
        }
      />
      <Route
        path='/my-tickets'
        element={
          <ProtectedRoute>
            <Tickets />
          </ProtectedRoute>
        }
      />
      <Route
        path='/my-tickets/details/:id'
        element={
          <ProtectedRoute>
            <TicketDetails />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default CommonRoutes;
